// extracted by mini-css-extract-plugin
export default {"resultsCount":"click-and-collect-results_resultsCount__dd858","clickCollectAboutCharges":"click-and-collect-results_clickCollectAboutCharges__1fb0b"};